import { render } from "./AppMain.vue?vue&type=template&id=5f624ca1&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=5f624ca1&scoped=true&lang=css"

import exportComponent from "F:\\MUZI\\com-muzimuzi-saas\\muzi-saas-admin-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f624ca1"]])

export default __exports__